import Vue from 'vue'
import BaseAlertInline from './components/BaseAlertInline'
import BaseCheckbox from './components/BaseCheckbox'
import BasePreloader from './components/BasePreloader'
import BaseSvg from './components/BaseSvg'
import BaseInput from './components/BaseInput'
import BaseRadioList from './components/BaseRadioList'
import BaseSelect from './components/BaseSelect'

Vue.component('BaseAlertInline', BaseAlertInline)
Vue.component('BasePreloader', BasePreloader)
Vue.component('BaseSvg', BaseSvg)
Vue.component('BaseInput', BaseInput)
Vue.component('BaseCheckbox', BaseCheckbox)
Vue.component('BaseRadioList', BaseRadioList)
Vue.component('BaseSelect', BaseSelect)
